<li *ngIf="isStandalone && canSendLeadToInsurer()">
  <a class="dropdown-item clickable" (click)="openModal()" i18n>
    Envoyer l'offre à Groupe Mutuel
  </a>
</li>

<ng-template #content let-modal>
  <div class="modal-body">
    @if (loadingRelatedLeads) {
      <div class="py-5">
        <app-spinner />
      </div>
    } @else {
      <form
        (ngSubmit)="sendLeadToInsurer().subscribe()"
        [formGroup]="form"
        class="lty-form"
      >
        <div class="modal-title mb-16" i18n>
          Envoyer l'offre à Groupe Mutuel
        </div>

        <div class="form-group flex-basis-100">
          <label for="customerSupportAgent" i18n
            >Chargé de clientèle<span class="text-danger">*</span></label
          >
          <div class="position-relative">
            <select
              name="roleId"
              class="form-control"
              formControlName="customerSupportId"
            >
              <option [value]="" i18n>Choisir un chargé de clientèle</option>
              <option
                *ngFor="let option of customerSupportList"
                [value]="option.adminId"
              >
                {{ option.firstName }} {{ option.lastName }}
              </option>
            </select>
            <i class="bi bi-chevron-down edge-element"></i>
          </div>
        </div>

        @if (isAttendingDoctorNumberRequired) {
          <div class="form-group flex-basis-100 mt-2">
            <label for="customerSupportAgent" i18n
              >N°RCC du médecin de premier recours<span class="text-danger"
                >*</span
              ></label
            >
            <input
              class="form-control"
              formControlName="attendingDoctorNumber"
            />
          </div>
        }

        <div class="consents-container mt-2" formGroupName="consents">
          <h3 class="color-neutral3 summary-title" i18n>Consentements</h3>
          <div class="d-flex gap-2 mt-3 flex-column">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="identificationArticle45"
                id="identificationArticle45"
                name="identificationArticle45"
              />
              <label class="form-check-label" for="identificationArticle45">
                <ng-container i18n
                  >J'ai identifié le demandeur d'assurance au moyen de la
                  feuille d'information selon l'art. 45 LSA</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="coveragePremiumInfo"
                id="coveragePremiumInfo"
                name="coveragePremiumInfo"
              />
              <label class="form-check-label" for="coveragePremiumInfo">
                <ng-container i18n
                  >Je l'ai informé des risques assurés, de la nature et de
                  l’étendue des couvertures d’assurances et des
                  primes</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="dutiesAltModel"
                id="dutiesAltModel"
                name="dutiesAltModel"
              />
              <label class="form-check-label" for="dutiesAltModel">
                <ng-container i18n
                  >Je l'ai informé des devoirs de l’assuré dans le cadre du
                  modèle alternatif d’assurance</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="discountsComboFamily"
                id="discountsComboFamily"
                name="discountsComboFamily"
              />
              <label class="form-check-label" for="discountsComboFamily">
                <ng-container i18n
                  >Je l'ai informé des conditions d’octroi et de perte des
                  rabais de combinaison et des rabais familiaux</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="overviewProvided"
                id="overviewProvided"
                name="overviewProvided"
              />
              <label class="form-check-label" for="overviewProvided">
                <ng-container i18n
                  >Je lui ai remis et expliqué l’aperçu</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="generalConditionsProvided"
                id="generalConditionsProvided"
                name="generalConditionsProvided"
              />
              <label class="form-check-label" for="generalConditionsProvided">
                <ng-container i18n
                  >Je lui ai remis et expliqué les conditions
                  générales</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="art45InfoSheetProvided"
                id="art45InfoSheetProvided"
                name="art45InfoSheetProvided"
              />
              <label class="form-check-label" for="art45InfoSheetProvided">
                <ng-container i18n
                  >Je lui ai remis et expliqué la feuille d’information selon
                  l’art.45 LSA</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="specialConditionsProvided"
                id="specialConditionsProvided"
                name="specialConditionsProvided"
              />
              <label class="form-check-label" for="specialConditionsProvided">
                <ng-container i18n
                  >Je lui ai remis et expliqué les conditions
                  particulières</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="startDurationTermination"
                id="startDurationTermination"
                name="startDurationTermination"
              />
              <label class="form-check-label" for="startDurationTermination">
                <ng-container i18n
                  >Je l'ai informé du début et de la durée, par produit
                  d’assurance ainsi que des délais de résiliation</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="waitingPeriodsHospitalMaternity"
                id="waitingPeriodsHospitalMaternity"
                name="waitingPeriodsHospitalMaternity"
              />
              <label
                class="form-check-label"
                for="waitingPeriodsHospitalMaternity"
              >
                <ng-container i18n
                  >Je l'ai informé des délais de carence possible sur certains
                  produits d’assurances en cas d’hospitalisation et de
                  maternité</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="revocationRight"
                id="revocationRight"
                name="revocationRight"
              />
              <label class="form-check-label" for="revocationRight">
                <ng-container i18n
                  >Je l'ai informé du droit de révocation de contrats, de la
                  forme et du délai à respecter pour la révocation</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="formalApplication"
                id="formalApplication"
                name="formalApplication"
              />
              <label class="form-check-label" for="formalApplication">
                <ng-container i18n
                  >Je lui fait prendre connaissance qu'il ne s’agit pas d’une
                  demande d’offre mais d’une demande formelle de conclure un
                  contrat d’assurance auprès de l’assureur
                  concerné</ng-container
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="signedScheduledAppointment"
                id="signedScheduledAppointment"
                name="signedScheduledAppointment"
              />
              <label class="form-check-label" for="signedScheduledAppointment">
                <ng-container i18n
                  >Il confirme avoir signé la présente proposition d’assurance
                  lors d’un rendez-vous fixé suite à un contact avec son
                  consentement préalable</ng-container
                >
              </label>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end w-100 mt-4">
          <button
            type="button"
            class="lty-btn lty-btn-white"
            (click)="modal.close('Close click')"
            i18n
          >
            Annuler
          </button>
          <button
            type="submit"
            [disabled]="!canSubmit()"
            class="lty-btn lty-btn-primary ms-2"
            i18n
          >
            Envoyer l'offre à Groupe Mutuel
          </button>
        </div>
      </form>
    }
  </div>
</ng-template>
